const tabs = [
  ["overview", "Overview", "fa-chart-pie"],
  ["today", "Today", "fa-sun"],
  ["tomorrow", "Tomorrow", "fa-calendar-day"],
  ["scheduled", "Scheduled", "fa-repeat"],
  ["orders", "All orders", "fa-box"],
  ["users", "Users", "fa-users"],
];

export default function AdminTabs({ active, onChange }) {
  return (
    <div className="admin-tabs" role="tablist">
      {tabs.map(([id, label, icon]) => (
        <button key={id} className={active === id ? "active" : ""} onClick={() => onChange(id)}>
          <i className={`fa-solid ${icon}`} /> {label}
        </button>
      ))}
    </div>
  );
}
